/**
 * Configuración de la vista de lista "Variantes" (metadata-driven).
 * Los valores se definen en cada producto al asignar la variante.
 */

import { ProductIcon } from '@/lib/polaris-icons';
import type { ListViewConfig } from '@/types/listView.types';
import { ROUTES } from '@/config/routes.config';

export interface VariantListItem {
  id: string;
  name: string;
  product_count?: number;
}

export type NavigateFn = (path: string) => void;

export interface VariantsListConfigOptions {
  onAddVariant: () => void;
}

/**
 * Devuelve la config de la lista de variantes.
 * Recibe toUrl (navegación con store) y options para la acción primaria y empty state (modal crear variante).
 */
export function getVariantsListConfig(
  toUrl: NavigateFn,
  options: VariantsListConfigOptions
): ListViewConfig<VariantListItem> {
  return {
    title: 'Variantes',
    titleIcon: ProductIcon,
    onBack: () => toUrl(ROUTES.PRODUCTS),
    backAccessibilityLabel: 'Volver a Productos',
    primaryAction: {
      onAction: options.onAddVariant,
    },
    resourceName: {
      singular: 'variante',
      plural: 'variantes',
    },
    columns: [
      {
        key: 'name',
        title: 'Nombre de variante',
        type: 'text',
        fontWeight: 'medium',
      },
      {
        key: 'product_count',
        title: 'Usado en productos',
        type: 'number',
        format: (value, _item) =>
          `${value ?? 0} ${(value ?? 0) === 1 ? 'producto' : 'productos'}`,
      },
      {
        key: 'actions',
        title: 'Acciones',
        type: 'actions',
        editLabel: 'Editar',
        deleteLabel: 'Eliminar',
        delete: true,
      },
    ],
    emptyState: {
      heading: 'No hay variantes creadas',
      description:
        'Crea variantes por nombre (ej. Color, Talla). Los valores los defines en cada producto al asignar la variante.',
      image: 'https://cdn.shopify.com/s/files/1/0262/4071/2726/files/emptystate-files.png',
      action: {
        content: 'Agregar variante',
        onAction: options.onAddVariant,
      },
    },
    bulkActions: [
      { content: 'Exportar datos', actionKey: 'export' },
      // "Eliminar" lo inyecta la plantilla vía prop `bulkDelete`.
    ],
    idKey: 'id',
  };
}
